import { Theme } from '@mui/material'
import { css } from '@emotion/react'

export const emptyHazardAccordion = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${theme.palette.white.main};
  padding: 4px 8px;
  border-radius: 3px;
  border: 1px solid ${theme.palette.uintel.main}80;
  font-weight: 600;
  color: ${theme.palette.uintel.dark};
  line-height: 1.6;
`

export const toggleIcon = (isShown: boolean) => css`
  cursor: pointer;
  margin-left: auto;
  border-radius: 4px;
  opacity: ${isShown ? 1 : 0.5};

  &:hover {
    box-shadow:
      0 0 0 2px rgba(0, 0, 0, 0.05),
      inset 0 0 0 24px rgba(0, 0, 0, 0.05);
  }
  transition:
    box-shadow 0.1s ease-in-out,
    opacity 0.1s ease-in-out;
`
